<template>
  <v-container>
    <v-container class="ma-0 pa-0">
      <v-row no-gutters>
        <v-col cols="12" sm="6">
          <h1 style="min-width: 200px;">Прайс-лист</h1>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex">
          <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>

          <div style="max-width: 250px;">
            <v-autocomplete
              v-model="priceId"
              :items="pricesSelectData"
              filled
              dense
              :disabled="loadingSingle"
            ></v-autocomplete>
          </div>

          <div class="pl-3">
            <price-create></price-create>
          </div>
        </v-col>
      </v-row>
      
    </v-container>

    <v-container class="pa-0 ma-0 mt-1">
      <v-progress-linear
        v-if="loadingSingle || loadingUpdate || loadingList"
        indeterminate
      ></v-progress-linear>
      <div v-if="Boolean(curPrice)" :key="curPriceVersionId">
        <v-row class="pa-0 ma-0">
          <v-col cols="8" class="pa-0 ma-0">
            <v-tabs v-model="tab">
              <v-tab href="#tab1">Настройки</v-tab>
              <v-tab>Работы</v-tab>
              <v-tab>Материалы</v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="4" class="pa-0 ma-0 pt-2 pr-3" style="background-color: white; text-align: right;">
            <v-spacer></v-spacer>
            <v-btn color="darken-1" icon class="mr-2" title="Сохранить" @click="save()"><v-icon>mdi-content-save-all</v-icon></v-btn>
            <v-btn color="darken-1" icon class="mr-2" title="Отмена" @click="restore()"><v-icon>mdi-backup-restore</v-icon></v-btn>
            <delete-button 
              :id="curPrice._id" 
              objName="прайс-лист"
              :deleteFunc="$store.dispatch"
              funcParam="prices/delete"
            >
              Название: {{ curPrice.name }}
            </delete-button>
          </v-col>
        </v-row>
        
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab1">
            <price-settings></price-settings>
          </v-tab-item>
          <v-tab-item>
            <services></services>
          </v-tab-item>
          <v-tab-item>
            <materials></materials>
          </v-tab-item>
        </v-tabs-items>

        <v-snackbar :value="curPriceChanged" :timeout="-1">
          Внимание! Прайс-лист изменен.

          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="save()"
            >
              Сохранить на сервере
            </v-btn>
          </template>
        </v-snackbar>
      </div>
      
      <v-alert v-if="!loadingSingle && !Boolean(curPrice) && !loadingList" type="warning" outlined dense>
        Данные не найдены. Выберите или создайте прайс-лист.
      </v-alert>
    </v-container>

  </v-container>
</template>

<script>
import PriceCreate from '../components/prices/PriceCreate';
import PriceSettings from '../components/prices/PriceSettings';
import Services from '../components/prices/Services';
import Materials from '../components/prices/Materials';
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    PriceCreate,
    PriceSettings,
    Services,
    Materials
  },

  data() {
    return {
      priceId: null,
      tab: 'tab1'
    };
  },

  async created() {
    document.title = 'Прайс-лист';
    await this.$store.dispatch('sites/loadEntitiesList', {tag: 'solution'});
    this.$store.dispatch('prices/loadList')
    .then(res => {
      this.priceId = this.$store.state.prices.curPrice ? this.$store.state.prices.curPrice._id : null;
    });
    
  },

  methods: {
    save() {
      this.$store.dispatch('prices/update').then(res => {
        this.$store.dispatch('showMessage', res.message);
      });
    },

    restore() {
      this.$store.dispatch('prices/loadSingle', this.curPrice._id).then(() => {
        this.$store.dispatch('showMessage', 'Восстановлен сохраненный прайс-лист.');
      });
    }
  },

  watch: {
    priceId(val) {
      if (this.curPrice && this.curPrice._id != val) {
        this.$store.dispatch('prices/loadSingle', val);
      }
    },
    curPrice(val) {
      this.priceId = val ? val._id : null
    }
  },

  computed: {
    ...mapState('prices', ['allPrices', 'curPrice', 'curPriceVersionId', 'curPriceChanged']),
    ...mapGetters('prices', ['loadingList', 'loadingSingle', 'loadingUpdate', 'pricesSelectData'])
  }
}
</script>